export const parseOptionalFontSize = (value: string): number | undefined => {
	if (value === '' || value === null || value === undefined) {
		return undefined;
	}

	const parsedValue = Number.parseInt(value, 10);
	return Number.isNaN(parsedValue) ? undefined : parsedValue;
};

export const getFontSizePlaceholder = (fontSizePx?: number, fallbackFontSizePx?: number): string => {
	if (fontSizePx !== undefined && fontSizePx !== null) {
		return String(fontSizePx);
	}

	return fallbackFontSizePx !== undefined ? String(fallbackFontSizePx) : 'Native';
};
